import {WithSummaryModel} from '../../../../../common/entity/dto/plain/withSummary.model';
import {FormModel} from '../../../../../form/form/api/entity/form.model';
import {TreatmentSummaryModel} from './treatmentSummary.model';
import {ConsultationSummaryModel} from '../../../../consultation/consultation/api/model/consultationSummary.model';

export class TreatmentModel extends WithSummaryModel<TreatmentSummaryModel> {
    form: FormModel;
    consultation: ConsultationSummaryModel;
}
